export default __webpack_public_path__ + "b646ba2.png";